export const environment = {
  production: true,
  client_id: 'd62a5363-d118-4c7b-9b92-6d09817a2849',
  app_url: 'https://dev.entitlement-global.es.xom.cloud/',
  base_api_url: 'https://ext.apiproxydev.exxonmobil.com/sccot-sc-entitlement-glb/v1',
  base_api_scope: 'api://sccot-sc-entitlement-global-api-nonprod/access_as_user',
  base_api_swagger:
    'https://ext.apiproxydev.exxonmobil.com/sccot-sc-entitlement-glb/v1/swagger/v1/swagger.json',
};